import styled, { css } from 'styled-components';

import {
  breakpoints,
  IconRegularOptions,
  theme,
} from '@notino/react-styleguide';

import { Hidden } from '@components/Hidden';

export const WishlistListsPageWrapper = styled.div`
  max-width: 64.75rem;
  margin: 0 auto;
  min-height: 500px;
  padding: 1.5rem 1rem 3rem;
  @media (min-width: ${breakpoints.md}) {
    padding: 4rem 1rem;
  }
`;

export const PageTitle = styled.h1`
  margin-bottom: 0.5rem;
  ${theme.typography.titleDisplay}
`;

export const PageDescription = styled.p`
  ${theme.typography.bodyRegular}
  color: ${theme.color.text.secondary};
  @media (min-width: ${breakpoints.md}) {
    ${theme.typography.bodyLarge}
  }
`;

export const NewListButton = styled.button`
  all: unset;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  cursor: pointer;
  margin: 1.5rem 0 1rem auto;

  ${theme.typography.labelRegular} span {
    text-decoration: underline;
  }

  &:hover span {
    text-decoration: none;
  }
`;

export const ListChunksContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @media (min-width: ${breakpoints.md}) {
    gap: 0;
  }
`;

export const ListsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @media (min-width: ${breakpoints.md}) {
    gap: 0;
    box-shadow: 0px 4px 8px 0px #4747471a, 0px 1px 2px 0px #4747470f;
    border-radius: 0.25rem;
  }
`;

export const ListItem = styled.a<{ isFirst: boolean; isLast: boolean }>`
  text-decoration: none;
  background: ${theme.color.background.primary};
  box-shadow: 0px 4px 8px 0px #4747471a, 0px 1px 2px 0px #4747470f;
  padding: 0.75rem;
  border-radius: 0.25rem;

  display: grid;
  grid-column-gap: 1rem;
  grid-template-columns: 1fr auto;
  grid-template-areas:
    'title options'
    'divider divider'
    'thumbnails thumbnails';

  @media (min-width: ${breakpoints.md}) {
    padding: 1rem;
    box-shadow: none;
    grid-template-areas: 'title thumbnails options';
    border-radius: 0;
    border-bottom: 1px solid ${theme.color.border.divider};

    ${({ isFirst }) =>
      isFirst &&
      css`
        border-radius: 0.25rem 0.25rem 0 0;
      `}

    ${({ isLast }) =>
      isLast &&
      css`
        border-bottom: none;
        border-radius: 0 0 0.25rem 0.25rem;
      `}
  }

  &:hover h6 {
    text-decoration: underline;
  }
`;

export const ItemTop = styled.div`
  grid-area: title;
  align-self: center;
`;

export const HideDivider = styled(Hidden)`
  margin: 0.75rem 0;
  grid-area: divider;
`;

export const Options = styled(IconRegularOptions)`
  grid-area: options;
  justify-self: end;
  align-self: center;
  width: 2rem;
  height: 52px;
  padding-block: 14px;
  border-radius: 100rem;

  &:hover {
    background-color: ${theme.color.background.primaryHover};
  }

  @media (min-width: ${breakpoints.md}) {
    width: 3.25rem;
  }
`;
